import React, {useEffect, useState} from "react";
import {Button, CircularProgress, Grid, TextField, Typography,} from "@material-ui/core";
import {withRouter, useParams} from "react-router-dom";

// styles
import useStyles from "./styles";

// logo
// context
import {connect} from "react-redux";
import {changePassword} from "../../datamanagement/actions";
import {Footer} from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import {CookieSnackbar} from "../../components/CookieSnackbar/CookieSnackbar";

function ResetPassword(props) {

    useEffect(() => {
        document.title = 'Passwort zurücksetzen - JobNinja Kundendashboard'
    })

    var classes = useStyles();
    let {token} = useParams();
    const [passwordValue, setPasswordValue] = useState("");
    const [confirmPasswordValue, setConfirmPasswordValue] = useState("")

    return (
        <>
            {(props.loading) ? <CircularProgress color="secondary"/> :
                <>
                    <Grid container className={classes.container}>
                        <Header history={props.history}/>
                        <div className={classes.formContainer}>
                            <div className={classes.form}>
                                <form onSubmit={(e) => {
                                    e.preventDefault()
                                    props.changePassword(
                                        token,
                                        confirmPasswordValue,
                                        props.history
                                    )
                                }}>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        Bitte geben Sie ein neues Passwort ein (mindestens 8 Zeichen):
                                    </Typography>
                                    <br/>
                                    <TextField
                                        id="password"
                                        InputProps={{
                                            classes: {
                                                underline: classes.textFieldUnderline,
                                                input: classes.textField,
                                            },
                                        }}
                                        value={passwordValue}
                                        onChange={e => setPasswordValue(e.target.value)}
                                        margin="normal"
                                        placeholder="Neues Passwort"
                                        type="password"
                                        fullWidth
                                        required
                                    />
                                    <TextField
                                        id="confirm_password"
                                        InputProps={{
                                            classes: {
                                                underline: classes.textFieldUnderline,
                                                input: classes.textField,
                                            },
                                        }}
                                        value={confirmPasswordValue}
                                        onChange={e => setConfirmPasswordValue(e.target.value)}
                                        margin="normal"
                                        placeholder="Neues Passwort wiederholen"
                                        type="password"
                                        fullWidth
                                        required
                                    />
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        size="medium"
                                        color="secondary"
                                        disabled={passwordValue.length <= 7 || passwordValue !== confirmPasswordValue}>
                                        Senden
                                    </Button>
                                </form>
                            </div>

                        </div>
                    </Grid>
                    <Grid>
                        <div className={classes.footer}>
                            <Footer/>
                        </div>
                    </Grid>
                    <CookieSnackbar/>
                </>
            }
        </>
    )
}

const mapStateToProps = (
{
    user
}
) =>
{
    return {user};
}


const mapDispatchToProps = dispatch =>
{
    return {
        changePassword: (token, confirmPasswordValue, history) => changePassword(dispatch, token, confirmPasswordValue, history),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResetPassword));